module.exports = __webpack_public_path__ + "img/Top-Users-by-Number-of-Reviewes-510x382.c9c72b1d.png";